import {Message} from "element-ui";
import {isArray, isObject} from "my-tools-kit";
import axios from "axios";
const spaceAxios = axios.create({
  baseURL:"",
});
/**
 * 上传图片之前拦截 如果返回false 就拦截返回阻止上传
 * @param file
 * @param imageSize {number}  单个文件（单张图片）大小限制 单位为MB
 * @param imageTypes  {Array<string>} 上传文件支持的类型
 * @param labelName {string}  文件描述，默认为“图片”
 * @returns {boolean}
 */
export function uploadImageBefore(file,imageSize=20,imageTypes=['image/jpeg', 'image/gif', 'image/bmp', 'image/png'],labelName = "图片") {
  // 要开始做文件上传的检查了
  // 文件类型
  if(isArray(imageTypes) && imageTypes.length){
    if (!imageTypes.includes(file.type)) {
      let typesArr = imageTypes.map(text =>{
        let arr = `${text}`.split("/");
        return arr[1];
      });
      let typesText = typesArr.join("、");
      Message.error(`${labelName}只能上传 ${typesText} 格式!`)
      return false
    }
  }
  // 文件大小
  if(!!imageSize){
    const maxSize = imageSize * 1024 * 1024
    if (maxSize < file.size) {
      Message.error(`上传${labelName}大小最大不能超过${imageSize}MB`)
      return false
    }
  }
  return true
}
/**
 * 上传图片并返回图片url
 * @param file
 * @param echoError
 * @returns {Promise<{code:number,message:string,data:{fileName:string,fileSize:number,fileUrl:string}}|Error>}
 */
export function getUrlAfterUploadImg(file,echoError=true){
  let url = "/api/customer/appUploadImage";
  const form = new FormData();
  form.append('file', file);
  return axios.post(url,form)
    .then(res=>{
      res = isObject(res.data) ? res.data : {};
      if(res.code !== 200) return Promise.reject(new Error(res.message));
      return res;
    })
    .catch(res => {
      console.error(res);
      if(echoError) Message.error(`上传图片：${res.message||"网络异常，请稍后再试"}`);
      return Promise.reject(res);
    })
}

// 上传文件（不限格式）并返回url
export function getUrlAfterUploadFile(file,echoError=true){
  let url = "/api/customer/unlimitedUploadImage";
  const form = new FormData();
  form.append('file', file);
  return axios.post(url,form)
    .then(res=>{
      res = isObject(res.data) ? res.data : {};
      if(res.code !== 200) return Promise.reject(new Error(res.message));
      return res;
    })
    .catch(res => {
      console.error(res);
      if(echoError) Message.error(`上传文件：${res.message||"网络异常，请稍后再试"}`);
      return Promise.reject(res);
    })
}

/**
 * 通过文件url下载文件
 * @param url
 * @param echoError
 */
export function downLoadFileUrl(url,echoError=true) {
  spaceAxios.get(url,{
    responseType: "arraybuffer" /* 一定要加这个 不然文件内容显示不了 */,
  })
    .then(res=>{
      if(res.status !== 200) return Promise.reject(Error(`status = ${res.status},${res.status||""}`));
      return res;
    })
    .then(res=>{
      let fileName = getUrlFileName(url)||"未命名";
      downFileBinaryStream(res.data,fileName);
    })
    .catch(res=>{
      console.error(res);
      if(echoError) Message.error(`下载文件：${res.message||"网络异常，请稍后再试"}`);
      return Promise.reject(res);
    })
}

/**
 * 接受处理文件二进制流
 */
export function downFileBinaryStream(data,fileName){
  let a = document.createElement("a");
  let blob = new Blob([data]);
  let objectUrl = URL.createObjectURL(blob);
  a.setAttribute("href", objectUrl);
  a.setAttribute("download", fileName);
  a.click();
  URL.revokeObjectURL(objectUrl); // 释放内存
}

/**
 * 通过文件url截取文件名
 * @param url
 */
export function getUrlFileName(url){
  let arr = url.split("/");
  let fileName = arr[arr.length-1]||"";
  return fileName;
}



// WEBPACK FOOTER //
// ./src/assets/js/utils.upload.js